import * as React from 'react';
import _ from 'lodash';
import MPCList, { MPCListProps, MPCListRef } from '@mpc/common/src/features/MPCList/index';
import { outsourceWorkbenchesList } from 'services/api';
import moment from 'moment';
import { Button, Space, Switch, Tag } from '@bedrock/components';
import CopyableNode from "@mpc/common/src/components/CopyableNode";
import { TagColor } from '@bedrock/components/lib/Tag';
import { useUpdateEffect } from 'ahooks';
import { ajax, showAlert } from 'utils';

const DEFAULT_FILTER_OPTIONS = {
  filterKeys: [
    {
      searchKey: 'product',
      optionKey: 'wb_products'
    },
    {
      searchKey:'demand_plan_users',
      optionKey: 'wb_plan_users'
    },
  ]
}

export default (props: any) => {
  const { getColumns, group_type = '', menuKey, ...rest } = props;

  const listRef = React.useRef<MPCListRef>();

  const handleChange = (body: { finished: boolean, id: string }) => {
    ajax({
      url: 'outsource/v2/demands/processed',
      method: 'POST',
      body,
    }).then((res: any) => {
      showAlert({
        type: 'success',
        message: res.res_msg,
      });
      listRef.current?.refreshTable();
    })
  }

  const customColumnsConf = {
    id: {
      width: 104,
      fixed: 'left',
      render: (v: any, r: any, i: number) => {
        return (
          <CopyableNode value={v} tipToolTitle="复制单号" />
        )
      }
    },
    quote_deadline: {
      align: 'left',
      width: 268,
      render: (v: any, r: any, i: number) => {
        const diffHours = moment(v).diff(moment().startOf('days'), 'hours');
        let info = '';
        let color: TagColor = 'light-grey';
        if (diffHours < 0) {
          info = '已过期';
          color = 'light-grey';
        } else if (diffHours >= 0 && diffHours < 24) {
          info = '今天过期';
          color = 'light-red';
        } else if (diffHours >= 24) {
          const diffDays = _.round(diffHours / 24, 0);
          if (diffDays <= 3) {
            info = `剩余${diffDays}天过期`;
            color = 'light-orange';
          }
        }
        return (
          <Space size="xxs">
            {v}
            {info ? 
              <Tag
                size="xSmall"
                color={color}
                text={info}
              /> : null}
          </Space>
        );
      },
    },
    finished: {
      width: 160,
      align: 'left',
      fixed: 'right',
      render: (v: any, r: any, i: number) => {
        return (
          <Space size="xs" onClick={e => { e.stopPropagation(); }} >
            <Switch
              checked={!v}
              labelOn="待处理"
              labelOff="已处理"
              onChange={(e: any) => {
                handleChange({
                  finished: !r.finished,
                  id: r.id,
                })
              }}
            />
          </Space>
        );
      },
    },
    operation: {
      fixed: 'right',
      render: (v: any, r: any, i: number) => {
        return r['can_move_wb'] ? (
          <Button type='link'>处理</Button>
        ) : null;
      },
    },
    ...(getColumns?.())
  }

  const fetchList: MPCListProps['fetchList'] = (params) => {
    return outsourceWorkbenchesList({
      ...params,
      size: params.pageSize,
      state: (_.snakeCase(menuKey || '')).toUpperCase() as any,
    })
  }

  useUpdateEffect(() => {
    setTimeout(() => {
      listRef.current?.filterRef?.current?.reset();
          // listRef.current?.refreshTable?.();
    }, 100);
  }, [menuKey])

  return (
    <MPCList
      filterOptions={DEFAULT_FILTER_OPTIONS}
      group_type={group_type}
      menuKey={menuKey}
      ref={listRef}
      fetchList={fetchList}
      customColumnsConf={customColumnsConf}
      contentClassName="pd-l-16 pd-r-16"
      ProTablePlusProps={{
        toolbar: {
          search: {
            placeholder: '请输入单号/项目名称',
            id: 'search_text',
          },
        }
      }}
      {...rest}
    />
  );
}
